import dynamic from "next/dynamic";

export const DynamicContent067 = dynamic(() => import("./Content067"), {
  suspense: true,
});
